import React, { SyntheticEvent, useState } from 'react'
import { useGetIdsReferencesCountries, CountryRefIds } from '@toktokdoctech/tokapi-client'
import TokTokDocAutocomplete from './Autocomplete'
import { CountrySearchProps } from './_props/CountrySearchProps'
import useDebounce from '../../hooks/useDebounce'

export default function CountrySearch({
    onCountrySearchChange,
    onSearchValueChange,
    initialValue,
    error,
    disabled,
    onBlur,
}: CountrySearchProps) {
    const [searchText, setSearchText] = useState('')

    const debouncedSearchText = useDebounce(searchText, 300)

    const { data, isFetching } = useGetIdsReferencesCountries({
        search: debouncedSearchText,
    })

    const countries = data ?? []

    const onAutocompleteChange = (_event: SyntheticEvent, value: string) => {
        setSearchText(value)
        if (onSearchValueChange) onSearchValueChange(value)
    }

    const onSelectedAutocomplete = (_event: SyntheticEvent, newValue: CountryRefIds) => {
        onCountrySearchChange(newValue)
    }

    return (
        <TokTokDocAutocomplete<CountryRefIds | undefined>
            id="country-search"
            searchText={searchText}
            value={initialValue}
            options={countries}
            loading={isFetching}
            error={error}
            renderOption={(option) => option?.name ?? ''}
            onAutocompleteChange={onAutocompleteChange}
            onSelectedAutocomplete={onSelectedAutocomplete}
            disabled={disabled}
            variant="outlined"
            clearOnBlur
            onBlur={onBlur}
            placeholder="Rechercher un pays"
        />
    )
}
